import { type ComponentType, memo, useRef } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import { VirtualContent, VirtualWrapper, Wrapper } from './VirtualPanel.styles';

const VirtualPanelBase = <Item extends object>({
  items,
  Component,
  className,
  onClick,
}: {
  items: Item[];
  Component: ComponentType<{ row: Item; onClick: (iconName: string) => void }>;
  className?: string;
  onClick(iconName: string): void;
}) => {
  const listRef = useRef<HTMLDivElement>(null);
  const virtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => listRef.current,
    estimateSize: () => 50,
    overscan: 5,
  });

  const virtualItems = virtualizer.getVirtualItems();

  return (
    <>
      <Wrapper ref={listRef} className={className}>
        <VirtualWrapper height={virtualizer.getTotalSize()}>
          <VirtualContent start={virtualItems[0]?.start} className="virtual-content">
            {virtualItems.map(({ index, key }) => {
              const item = items[index];
              return <Component key={key} row={item} onClick={onClick} />;
            })}
          </VirtualContent>
        </VirtualWrapper>
      </Wrapper>
    </>
  );
};

export const VirtualPanel = memo(VirtualPanelBase) as typeof VirtualPanelBase;
